var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{style:('max-width:'+_vm.width),attrs:{"id":'olivertooltip-' + this.myid,"tabindex":"0","data-toggle":"tooltip","title":_vm.text}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }